import type React from "react";
import type { FunctionComponent } from "react";
import type { IconProps } from "@tamagui/helpers-icon";
import { Circle, type ViewProps, YStack } from "@medbillai/ui";
interface ShadowCircleHeaderProps {
  children?: React.ReactNode;
  icon?: FunctionComponent<IconProps>;
  iconStyle?: IconProps;
  circleWrapperProps?: ViewProps;
}
export function ShadowCircleHeader({
  children,
  icon: Icon,
  iconStyle,
  circleWrapperProps
}: ShadowCircleHeaderProps) {
  return <YStack alignItems="center" data-sentry-element="YStack" data-sentry-component="ShadowCircleHeader" data-sentry-source-file="ShadowCircleHeader.tsx">
      <Circle size="$8" backgroundColor="$background" zIndex={2} justifyContent="center" alignItems="center" boxShadow="0px 4px 6px rgba(0,0,0,0.08)" {...circleWrapperProps} data-sentry-element="Circle" data-sentry-source-file="ShadowCircleHeader.tsx">
        {Icon ? <Icon size={36} strokeWidth={2} color="$iconDefault" {...iconStyle} /> : null}
        {children}
      </Circle>
    </YStack>;
}